import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomDiamondShineSolid = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            d="M7.99997 13.6668L1.99997 7.7335L5.3333 3.66683H10.6666L14 7.7335L7.99997 13.6668ZM3.04997 3.66683L1.6333 2.25016L2.5833 1.31683L3.99997 2.7335L3.04997 3.66683ZM7.3333 2.3335V0.3335H8.66664V2.3335H7.3333ZM12.9166 3.66683L11.9666 2.71683L13.3833 1.30016L14.3333 2.25016L12.9166 3.66683ZM7.99997 11.8002L11.5 8.3335H4.49997L7.99997 11.8002ZM5.96663 5.00016L4.31663 7.00016H11.6833L10.0333 5.00016H5.96663Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={0.1}
        />
    </SvgIcon>
);
